require("!!/home/jormat/jormat-front/node_modules/script-loader/addScript.js")(require("!!/home/jormat/jormat-front/node_modules/raw-loader/index.js!/home/jormat/jormat-front/bower_components/moment/moment.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/moment/moment.js
// module id = 530
// module chunks = 0